import { RECOMMENDATION_VALUES, recommendationWord } from "@/mc/labels";
import { STAGE_LABEL } from "./stageLabels.generated";
export { STAGE_LABEL };

/** Each stored recommendation's word (B14 C5): read from the design system's one mapping, never spelled here. */
export const RECOMMENDATION_LABEL: Record<string, string> = Object.fromEntries(
  RECOMMENDATION_VALUES.map((value) => [value, recommendationWord(value)?.label ?? value]),
);
export const QUESTIONS_LABEL = "Behavioural interview questions (recommended, not required)";

const PACKET_PAGE_LABEL: Record<string, string> = { interviewer: "My Interviews", hm: "My Packets", recruiter: "My Packets", hrbp: "My Packets", admin: "My Packets" };
export function packetSeatLabel(me: { roles: readonly string[] } | null | undefined): string {
  return me?.roles.map(role => PACKET_PAGE_LABEL[role]).find(Boolean) ?? "My Packets";
}

export const LEVEL_LABEL: Record<string, string> = {
  manager_and_below: "Manager & Below", director_srdirector: "Director & Sr Director", vp_and_above: "VP & Above",
};
export const REQUISITION_STATUS_LABEL: Record<string, string> = {
  draft: "Open — not posted", open: "Open", on_hold: "On hold", partially_filled: "Partially filled",
  accepted: "Offer Accepted", filled: "Filled", closed_cancelled: "Closed — cancelled", closed_filled: "Closed — filled", archived: "Archived",
};
